/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Policy_Rights_Portability_DescInputs */

const es_privacy_policy_rights_portability_desc = /** @type {(inputs: Privacy_Policy_Rights_Portability_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recibir sus datos en formato legible por maquina`)
};

const en_privacy_policy_rights_portability_desc = /** @type {(inputs: Privacy_Policy_Rights_Portability_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Receive your data in a machine-readable format`)
};

/**
* | output |
* | --- |
* | "Receive your data in a machine-readable format" |
*
* @param {Privacy_Policy_Rights_Portability_DescInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const privacy_policy_rights_portability_desc = /** @type {((inputs?: Privacy_Policy_Rights_Portability_DescInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Policy_Rights_Portability_DescInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_privacy_policy_rights_portability_desc(inputs)
	return en_privacy_policy_rights_portability_desc(inputs)
});
export { privacy_policy_rights_portability_desc as "privacy_policy.rights.portability_desc" }